var map = {
	"./culture-2.png": 1317,
	"./culture.png": 1316,
	"./ecology-2.png": 1299,
	"./ecology-3.png": 1300,
	"./ecology-4.png": 1301,
	"./ecology-completed.png": 2478,
	"./ecology.png": 1298,
	"./entrepreneurship.png": 1302,
	"./improvment-2.png": 1310,
	"./improvment-3.png": 1311,
	"./improvment-4.png": 1312,
	"./improvment.png": 1309,
	"./movement.png": 1313,
	"./park-2.png": 1307,
	"./park-3.png": 1308,
	"./park.png": 1306,
	"./railway.png": 1304,
	"./scooters.png": 1318,
	"./social.png": 1303,
	"./transport-ship.svg": 1315,
	"./transport.png": 1314,
	"./youth-2.png": 1297,
	"./youth.png": 1296,
	"./zoo.png": 1305
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2477;